const api = '/api/v1/u005_p_edit_item_controller.php';
import axios from 'axios';
export const edit_item_repository =  {
    get(data){
        return  axios.post(api,data);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

